<template>
  <v-card class="mx-auto my-12 marger" max-width="344" outlined>
    <v-list-item three-line>
      <v-list-item-content>
        <div class="overline mb-4">
          {{ mod.name }}
        </div>
        <v-list-item-subtitle>{{ mod.description }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions>
      <EditModal :mod="mod"/>
    </v-card-actions>
  </v-card>
</template>
<script>
import EditModal from "@/components/EditModal.vue";

export default {
  name: "Mods",
  props: {
    mod: Object,
  },
  components: {
    EditModal
  }
};
</script>

<style scoped>
.price-wrapper {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.sale {
  color: #e43011;
}

.white {
  color: white !important;
}

.marger {
  margin: 0 10px;
  background-color: transparent;
  margin-bottom: 10px;
}

@media (max-width: 767px) {
  .marger {
    max-width: 325px !important;
  }
}
</style>
